import React from 'react'

const Header = () => {
  return (
    <header>
        <h1>Expense Tracker</h1>
    </header>
  )
}

export default Header